export default {
  navigationBarTitleText: '发票助手'
};
